function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { Flag } from '@nordlayer/rivendell-ui';
import EuFlagIcon from 'assets/img/flag-eu.svg';
import { ACTIVITY_LIST_PATH } from 'routing/routes/activity/constants';
import { LOGOUT_PATH } from 'routing/routes/auth/constants';
import { DISTRIBUTORS_LIST_PATH } from 'routing/routes/distributors/constants';
import { PARTNERS_PATH } from 'routing/routes/partners/constants';
import { EuFlag, OptionLabel } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var REGION_KEY = 'region';
export var AvailableRegions = {
    US: 'us',
    EU: 'eu'
};
export var DEFAULT_REGION = AvailableRegions.US;
export var REGION_DISPLAY_NAMES = _defineProperty(_defineProperty({}, AvailableRegions.US, 'US Data Center'), AvailableRegions.EU, 'EU Data Center');
/**
 * Paths allowed per region. A missing entry means every page is allowed.
 */
export var REGION_ALLOWED_PATHS = _defineProperty({}, AvailableRegions.EU, [PARTNERS_PATH, DISTRIBUTORS_LIST_PATH, ACTIVITY_LIST_PATH, LOGOUT_PATH]);
export var REGION_OPTIONS = [{
        value: AvailableRegions.US,
        label: /*#__PURE__*/ _jsxs(OptionLabel, {
            children: [/*#__PURE__*/ _jsx(Flag, {
                    countryCode: "US"
                }), "US DC"]
        })
    }, {
        value: AvailableRegions.EU,
        label: /*#__PURE__*/ _jsxs(OptionLabel, {
            children: [/*#__PURE__*/ _jsx(EuFlag, {
                    src: EuFlagIcon,
                    alt: "eu-flag-icon"
                }), "EU DC"]
        })
    }];
